// extracted by mini-css-extract-plugin
export default {"container":"styles_container__tTjOl","label":"styles_label__EEq3l"};